import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Track create / edit modal.
 */
import React, { useState } from 'react';
import { Form, Input, Modal } from 'antd';
import { createTrack, updateTrack } from '../../api';
import { notifySuccess } from '../errors';
export function TrackModal({ open, onClose, onDone, gradeId, initial }) {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const initialValues = initial ? { name: initial.name, color: initial.color ?? '' } : undefined;
    const formKey = initial ? `edit-${initial.id}` : 'create';
    const submit = async () => {
        let v;
        try {
            v = await form.validateFields();
        }
        catch {
            return;
        }
        setSubmitting(true);
        try {
            const color = v.color?.trim() || null;
            if (initial) {
                await updateTrack(initial.id, { name: v.name.trim(), color });
                notifySuccess('המסלול עודכן');
            }
            else {
                await createTrack({ grade_id: gradeId, name: v.name.trim(), color });
                notifySuccess('מסלול נוצר');
            }
            onDone();
        }
        catch { /* client auto-surfaces */ }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsx(Modal, { title: initial ? 'עריכת מסלול' : 'יצירת מסלול', open: open, onCancel: onClose, onOk: submit, okText: initial ? 'שמור' : 'צור', cancelText: "\u05D1\u05D8\u05DC", confirmLoading: submitting, destroyOnHidden: true, children: _jsxs(Form, { form: form, layout: "vertical", preserve: false, initialValues: initialValues, children: [_jsx(Form.Item, { name: "name", label: "\u05E9\u05DD \u05D4\u05DE\u05E1\u05DC\u05D5\u05DC", rules: [{ required: true, message: 'שם נדרש' }], children: _jsx(Input, { placeholder: "\u05DC\u05DE\u05E9\u05DC: \u05D0\u05DC\u05D2\u05D1\u05E8\u05D4" }) }), _jsx(Form.Item, { name: "color", label: "\u05E6\u05D1\u05E2 (\u05D0\u05D5\u05E4\u05E6\u05D9\u05D5\u05E0\u05DC\u05D9)", children: _jsx(Input, { placeholder: "\u05DC\u05DE\u05E9\u05DC: purple / #6b21a8" }) })] }, formKey) }));
}
